import { ErrorCodesEnum } from "~/common/api/constants/error-code";

export interface ApiErrorOptions {
  message: string;
  status: number;
  statusText: string;
  url: string;
  method: string;
  errorCode?: ErrorCodesEnum;
  responsePayload?: unknown;
  requestPayload?: unknown;
}

/**
 * Custom error class for API-related errors
 * Extends the base Error class to include detailed request and response information
 */
export class ApiError extends Error {
  public readonly status: number;

  public readonly statusText: string;

  public readonly url: string;

  public readonly method: string;

  public readonly errorCode?: ErrorCodesEnum;

  public readonly responsePayload: unknown;

  public readonly requestPayload: unknown;

  constructor(options: ApiErrorOptions) {
    super(options.message);
    this.status = options.status;
    this.statusText = options.statusText;
    this.url = options.url;
    this.method = options.method;
    this.errorCode = options.errorCode;
    this.responsePayload = options.responsePayload;
    this.requestPayload = options.requestPayload;

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
  }

  /**
   * Returns a formatted string representation of the error
   */
  toString(): string {
    return `${this.name}: ${this.message} (${this.status} ${this.statusText}) - ${this.method} ${this.url}`;
  }

  /**
   * Returns detailed error information as an object
   */
  toJSON(): Record<string, unknown> {
    return {
      name: this.name,
      message: this.message,
      status: this.status,
      statusText: this.statusText,
      url: this.url,
      method: this.method,
      errorCode: this.errorCode,
      responsePayload: this.responsePayload,
      requestPayload: this.requestPayload,
    };
  }
}
